module.exports = __webpack_public_path__ + "static/img/smartProduct1.0266ddc7.png";